import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const getAllMailbox = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/mailbox?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const getOneMailbox = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/mailbox/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
